import { render, staticRenderFns } from "./DevicesPages.vue?vue&type=template&id=70f6eb48&scoped=true"
import script from "./DevicesPages.vue?vue&type=script&lang=js"
export * from "./DevicesPages.vue?vue&type=script&lang=js"
import style0 from "./DevicesPages.vue?vue&type=style&index=0&id=70f6eb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6eb48",
  null
  
)

export default component.exports